import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach token if stored (fallback for cross-domain cookie issues)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hse_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
